import { norsk_gassnett_api } from "@norskgassnett/shared";
import createClient from "openapi-react-query";
import { useAuthStore } from "../../store/auth-store";

// We create and set up the api client here
export const apiClient = norsk_gassnett_api.createApiClient({
	baseUrl: import.meta.env.VITE_API_URL,
});
apiClient.use(
	norsk_gassnett_api.authMiddleware({
		getToken: async () => useAuthStore.getState().token ?? undefined,
	}),
);
apiClient.use({
	onRequest: (options) => {
		options.request.headers.set("Accept-Language", "no, en;q=0.8");
	},
});

export const apiHooks = createClient<norsk_gassnett_api.paths>(apiClient);

export type Paths = norsk_gassnett_api.paths;
export type Schemas = norsk_gassnett_api.components["schemas"];

// biome-ignore lint/suspicious/noExplicitAny: We will allow it since we need to check for multiple cases
export const parseServerErrorMessage = (error?: any): string | undefined => {
	if (!error) return undefined;
	if (error instanceof Error) {
		return error.message;
	}
	return error.error ?? undefined;
};
